/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const systemStateStrings = {
  title: 'System State',
  tab: 'Latest Activities',

  columns: {
    index: 'ID',
    username: 'Username',
    activity: 'Activity name',
    activityDate: 'Activity Date',
  },

  subtitle: 'Everything users have done in the system, newest first',
  searchPlaceholder: 'Search by username or activity',
  empty: 'No matching activity',
  actionFailed: 'The log could not be loaded',
  fail: {
    list: 'Could not load the activity log',
  },

  summary: {
    caption: 'Log at a glance',
    total: 'Total activity',
    latest: 'Last activity',
  },

  exportNote: 'Export is not available from this screen at the moment.',

  exportExcel: 'Export to Excel',
  exportPdf: 'Export to PDF',
}

export const notificationsLogStrings = {
  loadFailed: 'The notification log could not be loaded',
  title: 'System Notifications Details',

  columns: {
    type: 'Type',
    status: 'Status',
    createdOn: 'Created On',
    startDate: 'Start Date',
    endDate: 'End Date',
  },

  messageColumns: {
    status: 'Status',
    lastStatusDate: 'Last Status Date',
    details: 'Details',
  },

  filter: 'Search',
  reset: 'Cancel',
  type: 'Type',
  status: 'Status',
  details: 'Details',
  preview: 'Preview',
  delete: 'Delete',
  close: 'Close',
  deleteConfirm: 'Are you sure you want to delete this Notification Event?',
  deleted: 'Operation Completed Successfully',
  deleteFailed: 'Operation Failed',
  yes: 'Yes',
  no: 'No',

  states: {
    New: 'New',
    Dispatching: 'Sending',
    Uncertain: 'Delivery needs review',
    Pending: 'Pending',
    Waiting: 'Waiting',
    Running: 'Running',
    Stopped: 'Stopped',
    Finished: 'Completed',
    Failed: 'Failed',
    Succeeded: 'Succeeded',
  },

  reviewHint: 'The mail server may have accepted this email. Check its provider trace using the message ID before deciding whether to retry.',
  traceReference: 'Provider trace reference',
  messageId: 'SMTP message ID',
  confirmSent: 'Confirm provider accepted it',
  confirmNotSent: 'Confirm not sent and retry',
  reviewed: 'Delivery review saved',
  reviewFailed: 'Could not save the delivery review',
  deletableState: 'Waiting',
}
